<div [siLoading]="loading" [blocking]="true">
  @if (!loading) {
    <si-application-header>
      <si-header-brand>
        <a siHeaderLogo routerLink="/" aria-label="Siemens" class="d-none d-md-flex"></a>
        <span class="application-name">{{ fullApplicationTitle }}</span>
      </si-header-brand>

      <si-header-navigation aria-label="Main navigation">
        <a
          si-header-navigation-item
          routerLinkActive="active"
          [routerLink]="['/', 'main', 'configuration']"
          >{{ 'NAV.SCHEDULE_CONFIGURATION' | translate }}</a
        >
        <a
          si-header-navigation-item
          routerLinkActive="active"
          data-tour-id="tour-results"
          [routerLink]="['/', 'main', 'results']"
          >{{ 'NAV.RESULTS' | translate }}</a
        >
      </si-header-navigation>

      <si-header-actions>
        <button
          type="button"
          class="btn btn-tertiary"
          data-tour-id="tour-workspaces"
          (click)="toggleSidebar()"
        >
          Workspaces
        </button>
        <button
          si-header-action-item
          type="button"
          icon="element-settings"
          [siHeaderDropdownTriggerFor]="settings"
        >
          {{ 'NAV.SETTINGS' | translate }}
        </button>
        <button
          type="button"
          icon="element-help"
          si-header-action-item
          [siHeaderDropdownTriggerFor]="help"
        >
          {{ 'NAV.HELP' | translate }}
        </button>
        <button
          name="test"
          type="button"
          si-header-account-item
          [imageUrl]="profilePhotoUrl() ?? undefined"
          [siHeaderDropdownTriggerFor]="account"
        >
        </button>
      </si-header-actions>
    </si-application-header>
  }

  <div class="si-layout-main-padding d-flex flex-column h-100 gap-8">
    <router-outlet />
  </div>

  @if (simulatingSchedule()) {
    <div class="bg-info text-white d-flex justify-content-center align-items-center fixed-bottom">
      <div class="w-100 px-4 py-2 gap-6 d-flex justify-content-center align-items-center">
        <span
          >{{ 'RESULTS.SIMULATION_FOR_RUNNING' | translate: { name: simulatingSchedule()?.name } }}
          <span class="loading-dots"></span
        ></span>
        <button type="button" class="btn btn-sm btn-tertiary" (click)="onCancelSimulation()">
          {{ 'SHARED.CANCEL' | translate }}
        </button>
      </div>
    </div>
  }

  <ng-template #settings>
    <si-header-dropdown>
      <button
        si-header-dropdown-item
        icon="element-language"
        type="button"
        [siHeaderDropdownTriggerFor]="language"
      >
        {{ 'NAV.SETTINGS.LANGUAGE' | translate }}
      </button>
      <button
        si-header-dropdown-item
        icon="element-palette"
        type="button"
        [siHeaderDropdownTriggerFor]="theme"
      >
        {{ 'Theme' | translate }}
      </button>
    </si-header-dropdown>
  </ng-template>

  <ng-template #help>
    <si-header-dropdown>
      <button si-header-dropdown-item type="button" (click)="startTour()">
        {{ 'NAV.HELP.TAKE_A_TOUR' | translate }}
      </button>
      <button si-header-dropdown-item type="button" (click)="downloadUserManual()">
        {{ 'NAV.HELP.INSTRUCTIONS' | translate }}
      </button>

      <a
        si-header-dropdown-item
        routerLinkActive="active"
        type="button"
        target="_blank"
        [routerLink]="['/', 'about']"
      >
        {{ 'NAV.HELP.ABOUT' | translate }}
      </a>

      <a
        si-header-dropdown-item
        routerLinkActive="active"
        type="button"
        target="_blank"
        rel="noopener noreferrer"
        [attr.href]="reportProblemUrl"
      >
        {{ 'NAV.HELP.REPORT_ISSUE' | translate }}
      </a>
    </si-header-dropdown>
  </ng-template>

  <ng-template #language>
    <si-header-dropdown>
      @for (language of languageItems; track language.id) {
        <button
          si-header-dropdown-item
          type="button"
          [checked]="getLanguage() === language.id ? 'check' : ''"
          (click)="switchLanguage(language.id ?? '')"
        >
          {{ language.label | translate }}
        </button>
      }
    </si-header-dropdown>
  </ng-template>

  <ng-template #theme>
    <si-header-dropdown>
      @for (theme of themeItems; track theme.id) {
        <button
          si-header-dropdown-item
          type="button"
          [checked]="getTheme() === theme.id ? 'check' : ''"
          (click)="switchTheme(theme.id ?? 'auto')"
        >
          {{ theme.label | translate }}
        </button>
      }
    </si-header-dropdown>
  </ng-template>

  <ng-template #account>
    <si-header-dropdown>
      <div class="mx-5">
        <div class="si-title-2 mb-2"
          >{{ accountSummary()?.givenName }} {{ accountSummary()?.familyName }}</div
        >
        <div class="mb-2 text-secondary">{{ accountSummary()?.gid }}</div>
        <div class="mb-2 text-secondary">{{ accountSummary()?.email }}</div>
        @for (role of accountSummary()?.roles; track $index) {
          <span class="badge bg-default mx-0">{{ role }}</span>
        }
      </div>
    </si-header-dropdown>
  </ng-template>

  <si-side-panel
    #sidePanel
    mode="over"
    size="wide"
    [collapsed]="sidebarCollapsed"
    (closed)="sidebarCollapsed = true"
  >
    <si-side-panel-content heading="Workspaces" class="d-flex flex-column h-100">
      @if (accountSummary(); as summary) {
        <app-workspaces [accountSummary]="summary" [availableWorkspaces]="availableWorkspaces()" />
      }
    </si-side-panel-content>
  </si-side-panel>
</div>
